import React from 'react';
import { View } from 'react-native';

import { validatePasswordStrength } from '../services/validationService';
import { cn } from '../utils/cn';

import { PasswordInput } from './PasswordInput';
import { ProgressBar } from './ProgressBar';
import ThemedText from './ThemedText';

interface PasswordInputWithStrengthProps {
  label: string;
  value: string;
  onChangeText: (text: string) => void;
  placeholder: string;
  showStrength?: boolean;
  error?: string;
  testID?: string;
  onSubmitEditing?: () => void;
}

export const PasswordInputWithStrength: React.FC<PasswordInputWithStrengthProps> = ({
  label,
  value,
  onChangeText,
  placeholder,
  showStrength = false,
  error,
  testID,
  onSubmitEditing,
}) => {
  const validation = validatePasswordStrength(value);
  const showMessage = showStrength && value.length > 0;
  const message = validation.error || 'Now confirm your new password';
  const hasError = !!validation.error;

  return (
    <View className='mb-4'>
      <PasswordInput
        label={label}
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        error={error}
        testID={testID}
        onSubmitEditing={onSubmitEditing}
      />

      {showMessage && (
        <>
          <ProgressBar strength={validation.strength} hasError={hasError} />
          <ThemedText
            type='bodySmall'
            className={cn('mt-2 min-h-[20px]', hasError ? 'text-login-gold-50' : 'text-login-green-50')}
          >
            {message}
          </ThemedText>
        </>
      )}
    </View>
  );
};
